import * as angular from "angular";
import {IController} from "angular";
import * as _ from 'lodash';

export class PlanningResourcesTableCtrl implements IController {
  resources: any;
  routes?: any;
  draft?: any;
  selectedIds: any;
  query: any;
  skills: any;
  areaIds: any;
  inRoute: any;
  onSelect: Function;
  onView: Function;
  onRemove: Function;
  onCreateARoute: Function;
  onAssignToRoute: Function;
  onAddToDraft: Function;
  onRemoveFromDraft: Function;


  public selectedKeys: any;
  public routesMapByResourceId: {} = {};
  private filteredResources: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.selectedKeys = {};
    this.selectedKeys = {};
    _.forEach(this.selectedIds, (selectedId) => {
      this.selectedKeys[selectedId] = true;
    });

    this.filteredResources = angular.copy(this.resources);
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if ((changes.selectedIds && !changes.selectedIds.isFirstChange()) ||
        (changes.resources && !changes.resources.isFirstChange())) {
      this.$onInit();
    }

    if (changes.skills && !changes.skills.isFirstChange() ||
      changes.areaIds && !changes.areaIds.isFirstChange() ||
      changes.inRoute && !changes.inRoute.isFirstChange() ||
      changes.query && !changes.query.isFirstChange()
    ) {
      this.filteredResources = _.filter(this.resources, (resource) => this.filterByFilters(resource));
    }

    if (changes.routes) {
      this.routesMapByResourceId = {};
      _.forEach(this.routes, (r) => {
        this.routesMapByResourceId[r.resourceId] = r;
      })
    }

  }

  onToggleResource(resource, isSelected) {
    this.selectedKeys[resource.id] = isSelected;
    const selectedIds = _.map(this.selectedKeys, (value, key) => {
      if (value) return key;
    });
    this.onSelect({ids: _.compact(selectedIds)});
  }


  onToggleAllResource() {
    const selectedIds = !_.isEqual(_.get(this.selectedIds, 'length', 0), this.filteredResources.length) ?
      _.map(this.filteredResources, (r) => {
        return r.id;
      }) : [];

    this.onSelect({ids: selectedIds});
  }


  private filterByFilters(resource) {

    const shouldReturnByQuery = this.filterByQuery(resource);
    const shouldReturnBySkill = this.filterBySkills(resource);
    const shouldReturnByAreaIds = this.filterByAreaIds(resource);
    const shouldReturnByInRoute = this.filterByInRoute(resource);

    return shouldReturnBySkill && shouldReturnByAreaIds && shouldReturnByInRoute && shouldReturnByQuery;
  }

  private filterByQuery(resource) {

    return !this.query ? true : _.includes(JSON.stringify(resource), this.query);

  }


  private filterBySkills(resource) {
    return !_.get(this.skills, 'length') || _.filter(resource.allocationSkills, (skill) => {
      return _.includes(this.skills, skill);
    }).length > 0;
  }


  private filterByAreaIds(resource) {
    return !_.get(this.areaIds, 'length') || _.filter(resource.areaIds, (aid) => {
      return _.includes(this.areaIds, aid);
    }).length > 0;
  }

  private filterByInRoute(resource) {
    return _.isUndefined(this.inRoute) || _.isEqual(resource.routed, this.inRoute);
  }


}

angular
  .module('bringoz.admin.planning')
  .component('planningResourcesTable', {
    bindings: {
      resources: '<',
      routes: '<?',
      draft: '<?',
      selectedIds: '<',
      query: '<?',
      skills: '<?',
      areaIds: '<?',
      inRoute: '<?',
      onSelect: '&',
      onView: '&',
      onRemove: '&',
      onCreateARoute: '&',
      onAssignToRoute: '&',
      onAddToDraft: '&',
      onRemoveFromDraft: '&'
    },
    template: require('./planning-resources-table.html').default,
    controller: PlanningResourcesTableCtrl
  });
